import lazyLoad from '@loadable/component'

import createPlugin from './createPlugin'

import FormRenderer from '@peracto/peracto-blocks-tailwind/dist/content/Form/Renderer/FormRenderer'

const FormForm = lazyLoad(() => import('./Form/FormForm'))

const formPlugin = settings =>
    createPlugin({
        Renderer: FormRenderer,
        Controls: FormForm,
        ...settings,
    })

const Form = formPlugin()
export default Form

export { formPlugin, FormRenderer }
